function sakuraInit() {
  const root = document.querySelector('[data-sakura-chat-root]');
  if (!root) return;

  const WORKER_URL  = root.getAttribute('data-worker-url') || '';
  const STORE_URL   = root.getAttribute('data-store-url') || window.location.origin;

  const toggleBtn   = root.querySelector('[data-sakura-toggle]');
  const menu        = root.querySelector('[data-sakura-menu]');
  const btnAI       = root.querySelector('[data-sakura-open-ai]');
  const btnWA       = root.querySelector('[data-sakura-open-wa]');
  const backdrop    = root.querySelector('[data-sakura-backdrop]');
  const chatWindow  = root.querySelector('[data-sakura-chat-window]');
  const closeBtn    = root.querySelector('[data-sakura-chat-close]');
  const messages    = root.querySelector('[data-sakura-messages]');
  const input       = root.querySelector('[data-sakura-input]');
  const sendBtn     = root.querySelector('[data-sakura-send]');

  const waDrawer    = root.querySelector('[data-wa-drawer]');
  const waClose     = root.querySelector('[data-wa-close]');

  let historico = [];
  let isLoading = false;

  // ── MENU ──────────────────────────────────────────────────

  function openMenu() {
    root.classList.add('menu-open');
  }

  function closeMenu() {
    root.classList.remove('menu-open');
  }

  function toggleMenu() {
    if (root.classList.contains('chat-open') || root.classList.contains('wa-open')) {
      closeAll();
      return;
    }
    root.classList.contains('menu-open') ? closeMenu() : openMenu();
  }

  function closeAll() {
    root.classList.remove('menu-open', 'chat-open', 'wa-open');
    if (waDrawer) waDrawer.setAttribute('aria-hidden', 'true');
  }

  // ── CHAT IA ───────────────────────────────────────────────

  function openChat() {
    closeMenu();
    root.classList.add('chat-open');
    if (messages.children.length === 0) {
      addMessage('assistant', 'Olá! Sou a Sakura, assistente virtual da Distribuidora Sakura. 🐠\n\nPosso ajudar com dúvidas sobre produtos e disponibilidade.\n\nComo posso ajudar?');
    }
    setTimeout(function () { input && input.focus(); }, 300);
  }

  function closeChat() {
    root.classList.remove('chat-open');
  }

  // ── WHATSAPP DRAWER ───────────────────────────────────────

  function openWaDrawer() {
    closeMenu();
    root.classList.add('wa-open');
    if (waDrawer) waDrawer.setAttribute('aria-hidden', 'false');
  }

  function closeWaDrawer() {
    root.classList.remove('wa-open');
    if (waDrawer) waDrawer.setAttribute('aria-hidden', 'true');
  }

  // ── MENSAGENS ─────────────────────────────────────────────

  function addMessage(role, text) {
    // Verifica se a IA sinalizou que precisa de atendimento humano
    const precisaHumano = text.includes('PRECISA_ATENDIMENTO_HUMANO');
    const textoLimpo = text.replace('PRECISA_ATENDIMENTO_HUMANO', '').trim();

    const div = document.createElement('div');
    div.className = 'sakura-chat-msg sakura-chat-msg--' + role;

    const bubble = document.createElement('div');
    bubble.className = 'sakura-chat-msg__bubble';

    // Converte URLs em links clicáveis com texto "ver produto"
    const comLinks = textoLimpo.replace(
      /(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" rel="noopener" style="color:#4ade80;text-decoration:underline;word-break:break-all;">ver produto</a>'
    );
    bubble.innerHTML = comLinks;
    div.appendChild(bubble);

    // Adiciona botão de WhatsApp se IA sinalizou que não tem resposta
    if (precisaHumano && role === 'assistant') {
      const btnWrap = document.createElement('div');
      btnWrap.style.cssText = 'margin-top:8px;';

      const btn = document.createElement('button');
      btn.style.cssText = 'display:inline-flex;align-items:center;gap:6px;padding:8px 14px;background:#22c55e;color:white;border:none;border-radius:999px;font-size:0.85rem;font-weight:600;cursor:pointer;';
      btn.innerHTML = '📱 Falar com atendente';
      btn.addEventListener('click', function () {
        closeChat();
        setTimeout(function () {
          if (btnWA) btnWA.click();
        }, 300);
      });

      btnWrap.appendChild(btn);
      div.appendChild(btnWrap);
    }

    messages.appendChild(div);
    scrollToBottom();
    return div;
  }

  function addLoadingMessage() {
    const div = document.createElement('div');
    div.className = 'sakura-chat-msg sakura-chat-msg--assistant sakura-chat-msg--loading';
    div.innerHTML = '<div class="sakura-chat-msg__bubble">' +
      '<span class="sakura-typing-dot"></span>' +
      '<span class="sakura-typing-dot"></span>' +
      '<span class="sakura-typing-dot"></span>' +
      '</div>';
    messages.appendChild(div);
    scrollToBottom();
    return div;
  }

  function scrollToBottom() {
    messages.scrollTop = messages.scrollHeight;
  }

  // ── BUSCA DE PRODUTOS ─────────────────────────────────────

 async function buscarProdutos(termo) {
  try {
    // Remove plurais simples e acentos para busca mais ampla
    const termoLimpo = termo
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // remove acentos
      .replace(/oes$/, 'ao')   // compressoes → compressao
      .replace(/ores$/, 'or')  // compressores → compressor
      .replace(/eiros$/, 'eiro')
      .replace(/metros$/, 'metro')
      .replace(/tros$/, 'tro')
      .replace(/s$/, '');      // plural genérico

    // Tenta com o termo original e com o termo limpo
    const termos = [...new Set([termo, termoLimpo])];
    let todosProdutos = [];

    for (const t of termos) {
      const url = '/search/suggest.json?q=' + encodeURIComponent(t) +
        '&resources[type]=product&resources[limit]=5' +
        '&resources[options][fields]=title,product_type,vendor';
      const resp = await fetch(url, { credentials: 'same-origin' });
      if (!resp.ok) continue;
      const data = await resp.json();
      const produtos = (data.resources && data.resources.results && data.resources.results.products) || [];
      todosProdutos = todosProdutos.concat(produtos);
      if (todosProdutos.length >= 5) break;
    }

    // Remove duplicados pelo id
    const vistos = new Set();
    const unicos = todosProdutos.filter(function (p) {
      if (vistos.has(p.id)) return false;
      vistos.add(p.id);
      return true;
    }).slice(0, 5);

    if (!unicos.length) return '';

    return unicos.map(function (p) {
      return '- Produto: ' + p.title +
        (p.vendor ? ' | Marca: ' + p.vendor : '') +
        ' | Link: ' + STORE_URL + p.url.split('?')[0];
    }).join('\n');

  } catch (e) {
    return '';
  }
}
  // ── ENVIO DE MENSAGEM ─────────────────────────────────────

  async function enviarMensagem() {
    if (isLoading) return;
    const texto = (input.value || '').trim();
    if (!texto) return;

    input.value = '';
    input.style.height = 'auto';
    isLoading = true;
    sendBtn.disabled = true;

    addMessage('user', texto);
    historico.push({ role: 'user', content: texto });
    const loadingEl = addLoadingMessage();

    try {
      const resp = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          mensagem: texto,
          historico: historico.slice(-6),
          loja_url: STORE_URL,
        }),
      });

      const data = await resp.json();
      const resposta = data.resposta || 'Desculpe, não consegui processar. Tente novamente. PRECISA_ATENDIMENTO_HUMANO';

      loadingEl.remove();
      addMessage('assistant', resposta);
      historico.push({ role: 'assistant', content: resposta });

      if (historico.length > 10) {
        historico = historico.slice(-10);
      }

    } catch (err) {
      loadingEl.remove();
      addMessage('assistant', 'Erro de conexão. PRECISA_ATENDIMENTO_HUMANO');
    }

    isLoading = false;
    sendBtn.disabled = false;
    input.focus();
  }

  // ── CSS do wa-open ────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = [
    '.sakura-chat-root.wa-open [data-sakura-backdrop]{opacity:1;pointer-events:auto;}',
    '.sakura-chat-root.wa-open .wa-quote-drawer{opacity:1;pointer-events:auto;transform:translateY(0);}',
  ].join('');
  document.head.appendChild(style);

  // ── LISTENERS ─────────────────────────────────────────────

  if (toggleBtn)  toggleBtn.addEventListener('click', toggleMenu);
  if (btnAI)      btnAI.addEventListener('click', openChat);
  if (btnWA)      btnWA.addEventListener('click', openWaDrawer);
  if (backdrop)   backdrop.addEventListener('click', closeAll);
  if (closeBtn)   closeBtn.addEventListener('click', closeChat);
  if (waClose)    waClose.addEventListener('click', closeWaDrawer);
  if (sendBtn)    sendBtn.addEventListener('click', enviarMensagem);

  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        enviarMensagem();
      }
    });
    input.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 100) + 'px';
    });
  }

  document.addEventListener('click', function (e) {
    if (root.classList.contains('menu-open') && !root.contains(e.target)) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sakuraInit);
} else {
  sakuraInit();
}